import type { FC } from 'react'

import Text from '@/app/translations/Text'
import { LocalDate } from '@/components/LocalDate'
import { useInjuryReportForm } from '@/forms/hooks'

import './InjuryReportStatus.styles.scss'

const InjuryReportStatus: FC = () => {
  const { data } = useInjuryReportForm()
  const { updated, managerName, status, type: injuryType } = data

  if (status === 'NEW') return null

  return (
    <section className="injury-report-status">
      <p className="injury-report-status__status">
        <Text id={`INJURY_REPORT_STATUS/${status}`} />
      </p>

      {injuryType !== 'DAMAGE' && (
        <p className="injury-report-status__manager">
          <Text id="Leder: {manager}" manager={managerName} />
        </p>
      )}

      <p className="injury-report-status__updated">
        <Text id="Oppdatert: {updated}" updated={<LocalDate date={updated} />} />
      </p>
    </section>
  )
}

export default InjuryReportStatus
